import ToolkitProvider, {Search} from "react-bootstrap-table2-toolkit";
import {NavLink} from "react-router-dom";
import React from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import moment from "moment";

const {SearchBar} = Search;
const columns = [
    {
        dataField: "sales_offer_id",
        text: "sales_offer_id",
        hidden: true,
    },
    {
        dataField: "sales_offer_reference",
        text: "Referentie",
        formatter: (cell, row) => <NavLink
            to={`/offer/${row.sales_offer_id}`}>{cell}</NavLink>,
        sort: true,
    },
    {
        dataField: "sales_offer_name",
        text: "Offertenaam",
        formatter: (cell, row) => <NavLink
            to={`/offer/${row.sales_offer_id}`}>{cell}</NavLink>,
        sort: true,
    },
    {
        dataField: "sales_offer_status",
        text: "Status",
        formatter: (cell) => {
            if (cell === "Binnengehaald") return <span className="badge bg-success">Binnengehaald</span>;
            else if (cell === "Gemist") return <span className="badge bg-danger">Gemist</span>;
            else if (cell === "Open") return <span className="badge bg-info">Open</span>;
            else return <span className="badge bg-warning text-dark">Onbekend</span>;
        },
        sort: true,
    },
    {
        dataField: "sales_offer_created_on",
        text: "Datum",
        formatter: (cell) => moment(cell).format("DD MMMM YYYY"),
        sort: true,
    },
];

export default function NawContactsDetailOffersTable({detailOffers}) {
    return (
        <ToolkitProvider
            keyField="sales_offer_id"
            data={detailOffers}
            columns={columns}
            search
        >
            {(props) => (
                <div>
                    <SearchBar srText={null}
                               {...props.searchProps}
                               placeholder={"Filter: Typ om te zoeken"}/>
                    <hr/>
                    <BootstrapTable
                        {...props.baseProps}
                        pagination={paginationFactory()}
                    />
                </div>
            )}
        </ToolkitProvider>
    );
}



